import React from 'react';
import PropTypes from 'prop-types';
import { getFieldLabel } from '../../config/fieldLabels';
import './AnnotationInfoPanel.scss';

/**
 * AnnotationInfoPanel component for displaying annotation details
 * Shows as a tooltip/modal overlay on the PDF viewer
 * Displays formatted classification details or raw data grid
 * 
 * @param {Object} annotation - The selected annotation object
 * @param {Function} onClose - Callback when panel is closed
 */
const AnnotationInfoPanel = ({ annotation, onClose }) => {
  if (!annotation) return null;

  const { id, title, type = 'info', data = {} } = annotation;
  const isClassificationAnnotation = id === 'klassement-first';

  const renderClassificationDetails = () => {
    return (
      <div className="annotation-info-panel__classification">
        <ul className="annotation-info-panel__classification-list">
          {data['274'] && data['274'] !== '0' && (
            <li>
              '<span className="annotation-info-panel__field-value">{data['274']}</span>' varken(s) hebben gemiddelde AFI van '<span className="annotation-info-panel__field-value">{data['285']}</span>'
            </li>
          )}
          <li>
            Gemiddelde vleesdikte van '<span className="annotation-info-panel__field-value">{data['282']}</span>'
          </li>
          <li>
            Gemiddelde spekdikte van '<span className="annotation-info-panel__field-value">{data['281']}</span>'
          </li>
          <li>
            Hiervan zijn '<span className="annotation-info-panel__field-value">{data['272']}</span>' zeugen & '<span className="annotation-info-panel__field-value">{data['273']}</span>' bargen & '<span className="annotation-info-panel__field-value">{data['289']}</span>' beren & '<span className="annotation-info-panel__field-value">{data['290']}</span>' improvac(s)
          </li>
          <li>
            Bevat '<span className="annotation-info-panel__field-value">{data['275']}</span>' % van de totale levering
          </li>
          <li>
            Het totaal koud gewicht van deze varkens is '<span className="annotation-info-panel__field-value">{data['276']}</span>' kg
          </li>
          <li>
            Gemiddelde gewichtstoeslag van deze '<span className="annotation-info-panel__field-value">{data['274']}</span>' varkens = '<span className="annotation-info-panel__field-value">{data['286']}</span>'
          </li>
        </ul>
      </div>
    );
  };

  return (
    <div className="annotation-info-panel">
      <div className="annotation-info-panel__overlay" onClick={onClose} />
      
      <div className="annotation-info-panel__modal">
        <div className="annotation-info-panel__header">
          <div className="annotation-info-panel__title-section">
            {isClassificationAnnotation ? (
              <h3 className="annotation-info-panel__title">
                In prijsklasse '<span className="annotation-info-panel__field-value">{data['271']}</span>':
              </h3>
            ) : (
              <h3 className="annotation-info-panel__title">{title}</h3>
            )}
          </div>
          <button
            className="annotation-info-panel__close-btn"
            onClick={onClose}
            aria-label="Close annotation panel"
          >
            ✕
          </button>
        </div>

        <div className="annotation-info-panel__content">
          {/* Display classification details in formatted text */}
          {isClassificationAnnotation && data && Object.keys(data).length > 0 && (
            renderClassificationDetails()
          )}

          {/* Display raw data grid for other annotations */}
          {!isClassificationAnnotation && data && Object.keys(data).length > 0 && (
            <div className="annotation-info-panel__section">
              <div className="annotation-info-panel__data-grid">
                {Object.entries(data).map(([key, value]) => (
                  <div key={key} className="annotation-info-panel__data-row">
                    <span className="annotation-info-panel__data-label">
                      {getFieldLabel(key)}:
                    </span>
                    <span className="annotation-info-panel__data-value">{value}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

AnnotationInfoPanel.propTypes = {
  annotation: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    type: PropTypes.oneOf(['info', 'warning', 'highlight']),
    data: PropTypes.object,
  }),
  onClose: PropTypes.func.isRequired,
};

export default AnnotationInfoPanel;
